export enum PillType {
  DayTime,
  Dropdown,
  Toggle,
}

export const DAYS_OF_THE_WEEK = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const TIMES_OF_THE_DAY = [
  'earlyMorning',
  'morning',
  'afternoon',
  'lateAfternoon',
  'evening',
];
